/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */
export const sideNavToggleTooltipKeyboardShortcut: string[] = ['Ctrl', '['];
